/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
//import { INodeProps } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import * as Msdyn365 from '@msdyn365-commerce/core';
import { IObrienTripleSliderData } from './obrien-triple-slider.data';
import { IObrienTripleSliderProps } from './obrien-triple-slider.props.autogenerated';

export interface IObrienTripleSliderViewProps extends IObrienTripleSliderProps<IObrienTripleSliderData> {
    slide1Title: React.ReactNode;
    slide1Image: React.ReactNode;
    slide1Link: string;
    slide2Title: React.ReactNode;
    slide2Image: React.ReactNode;
    slide2Link: string;
    slide3Title: React.ReactNode;
    slide3Image: React.ReactNode;
    slide3Link: string;
    
}

/**
 *
 * ObrienTripleSlider component
 * @extends {React.PureComponent<IObrienTripleSliderProps<IObrienTripleSliderData>>}
 */
class ObrienTripleSlider extends React.PureComponent<IObrienTripleSliderProps<IObrienTripleSliderData>> {
    public render(): JSX.Element | null {
        const { config } = this.props;

        const { 
            slide1Title,
            slide1Image,
            slide2Title,
            slide2Image,
            slide3Title,
            slide3Image,
            
        } = this.props.config;

        const Slide1Link = config.slide1Link ? config.slide1Link : 'No Link';
        const Slide2Link = config.slide2Link ? config.slide2Link : 'No Link';
        const Slide3Link = config.slide3Link ? config.slide3Link : 'No Link';
        

        // Slide 1
        const slideOneTitle = slide1Title && (
            <Msdyn365.Text
              tag={slide1Title.tag || 'h3'}
              text={slide1Title.text}
              editProps={{onEdit: this.handleTextChange1, requestContext:this.props.context.request}}
            />
        );

        const imageOneProps = {
            gridSettings: this.props.context.request.gridSettings || {},
            imageSettings: slide1Image && slide1Image.imageSettings,
        };

        const slideOneImage = slide1Image && (
            <Msdyn365.Image {...slide1Image} {...imageOneProps} editProps ={{key:this.props.config.slide1Image || {}, requestContext: this.props.context.request}}/>
        );

        // Slide 2
        const slideTwoTitle = slide2Title && (
            <Msdyn365.Text
              tag={slide2Title.tag || 'h3'}
              text={slide2Title.text}
              editProps={{onEdit: this.handleTextChange2, requestContext:this.props.context.request}}
            />
        );

        const imageTwoProps = {
            gridSettings: this.props.context.request.gridSettings || {},
            imageSettings: slide2Image && slide2Image.imageSettings,
        };

        const slideTwoImage = slide2Image && (
            <Msdyn365.Image {...slide2Image} {...imageTwoProps} editProps ={{key:this.props.config.slide2Image || {}, requestContext: this.props.context.request}}/>
        );

        // Slide 3
        const slideThreeTitle = slide3Title && (
            <Msdyn365.Text
              tag={slide3Title.tag || 'h3'}
              text={slide3Title.text}
              editProps={{onEdit: this.handleTextChange3, requestContext:this.props.context.request}}
            />
        );

        const imageThreeProps = {
            gridSettings: this.props.context.request.gridSettings || {},
            imageSettings: slide3Image && slide3Image.imageSettings,
        };

        const slideThreeImage = slide3Image && (
            /* @ts-ignore */
            <Msdyn365.Image {...slide3Image} {...imageThreeProps} editProps ={{key:this.props.config.slide3Image || {}, requestContext: this.props.context.request}}/>
        );

       

        const ObrienTripleSliderProps = {
            ...this.props,
            slide1Title: slideOneTitle,
            slide1Link: Slide1Link,
            slide1Image: slideOneImage,
            slide2Title: slideTwoTitle,
            slide2Link: Slide2Link,
            slide2Image: slideTwoImage,
            slide3Title: slideThreeTitle,
            slide3Link: Slide3Link,
            slide3Image: slideThreeImage
            
        };

        return this.props.renderView(ObrienTripleSliderProps);
    }
    public handleTextChange1 = (event: Msdyn365.ContentEditableEvent) => this.props.config.slide1Title!.text = event.target.value;
    public handleTextChange2 = (event: Msdyn365.ContentEditableEvent) => this.props.config.slide2Title!.text = event.target.value;
    public handleTextChange3 = (event: Msdyn365.ContentEditableEvent) => this.props.config.slide3Title!.text = event.target.value;
    
}

export default ObrienTripleSlider;
